document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.c_staff-blog[data-leeep-tag-id]');
  if (!section || section.dataset.initialized === 'true') return;
  section.dataset.initialized = 'true';

  const tagIds = {
    new: section.dataset.leeepNewTagId || section.dataset.leeepTagId || '',
    ranking: section.dataset.leeepRankingTagId || ''
  };
  let activeSort = 'new';
  let activeTagId = tagIds.new;
  const area = section.querySelector('[data-leeep-area="staff-blog"]');
  const sortButtons = [...section.querySelectorAll('[data-blog-sort]')];

  // 商品ブランドを LEEEP に追加しても、スタッフブログのブランド絞り込みには
  // スタッフ運用で使用するブランドだけを表示する。
  const staffBrandNames = new Set([
    'Tabioオンラインストア',
    '靴下屋',
    'Tabio',
    'Tabio MEN',
    '靴下屋UPDATE',
    'ｍaison peca',
    'Tabio本部'
  ]);

  const normalizeStaffBlogFilters = () => {
    section.querySelectorAll('.LeeepSearchFilterKey').forEach((key) => {
      const keyName = key.querySelector('.LeeepSearchFilterKeyName');
      if (!keyName) return;
      const filterName = keyName.textContent.trim();
      if (!['ブランド', '店舗', 'ハッシュタグ'].includes(filterName)) return;
      // 新着順とランキング順で LEEEP が返す DOM に差があっても、
      // 各見出し下の余白を同じスタイルで制御できるよう識別クラスを付与する。
      key.classList.add('c_staff-blog__filter-key--normalized');
      // LEEEPタグごとに絞り込み項目の出力順が異なるため、
      // 新着順／ランキング順の切り替え後も STG と同じ順番に固定する。
      const filterOrder = { 'ブランド': 0, 'ハッシュタグ': 1, '店舗': 2 };
      key.style.order = String(filterOrder[filterName]);

      const labels = [...key.querySelectorAll('.LeeepSearchFilterLabel')];
      labels.forEach((label) => {
        const valueName = label.querySelector('.LeeepSearchFilterValueName');
        const name = valueName ? valueName.textContent.trim() : '';
        const shouldHide = filterName === 'ブランド'
          ? !!name && !staffBrandNames.has(name)
          : name === 'すべて';
        label.hidden = shouldHide;
        // LEEEP 側の display:flex が hidden 属性より優先されるタグでも確実に非表示にする。
        label.style.display = shouldHide ? 'none' : '';
        label.classList.remove('c_staff-blog__filter-last-visible');
      });

      // LEEEP標準CSSの :last-of-type は、非表示項目が末尾に残ると判定が変わる。
      // 実際に表示している最終項目を明示し、タグ切り替え前後の余白を揃える。
      const visibleLabels = labels.filter((label) => !label.hidden && label.style.display !== 'none');
      visibleLabels.at(-1)?.classList.add('c_staff-blog__filter-last-visible');
    });
  };

  // 並び順切り替え時は LEEEP が絞り込み DOM を段階的に生成するため、
  // 後から追加されたブランド項目にも表示制御を再適用する。
  const staffBrandObserver = new MutationObserver(() => normalizeStaffBlogFilters());
  staffBrandObserver.observe(section, { childList: true, subtree: true });

  const renderLeeep = (id) => {
    if (!area || !id || typeof LeeepCite === 'undefined') return;
    area.textContent = '';
    const div = document.createElement('div');
    div.id = 'leeep-tag-' + String(id);
    area.appendChild(div);
    // 店舗階層へ変更した検索設定を、LEEEP の古い公開キャッシュから切り替える。
    LeeepCite.init({ tag_id: String(id), _cache_key: 'tabio-1183-20261014' });
  };

  const setSort = (sort) => {
    const nextTagId = tagIds[sort];
    if (!nextTagId || sort === activeSort) return;
    activeSort = sort;
    activeTagId = nextTagId;
    sortButtons.forEach((button) => {
      const isActive = button.dataset.blogSort === sort;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });
    area.innerHTML = '<p class="c_staff-blog__notice">読み込み中...</p>';
    renderLeeep(activeTagId);
  };

  sortButtons.forEach((button) => {
    button.addEventListener('click', () => setSort(button.dataset.blogSort));
    if (!tagIds[button.dataset.blogSort]) button.hidden = true;
  });

  const waitForLeeep = (count = 0) => {
    if (typeof LeeepCite !== 'undefined') { renderLeeep(activeTagId); return; }
    if (count > 50) {
      const errorText = section.dataset.leeepErrorText || '';
      if (area && errorText) area.textContent = errorText;
      return;
    }
    setTimeout(() => waitForLeeep(count + 1), 100);
  };

  if (activeTagId) waitForLeeep();

  // 詳細ページのハッシュタグから sessionStorage 経由で受け取った絞り込み条件（ワンショット）。
  // 他の一覧（コーデ/ランキング）と挙動を揃え、LEEEP標準のチップ式(?hashtag=)ではなく
  // チェックボックス絞り込みを適用する。読み取った時点で削除し、再適用を防ぐ。
  let pendingFilterValues = [];
  try {
    const rawPending = sessionStorage.getItem('c_leeepPendingFilters');
    if (rawPending) {
      const parsed = JSON.parse(rawPending);
      // 3一覧（コーデ/ランキング/ブログ）でキーを共有しているため、target が自分宛て（staff-blog）
      // のときだけ消費する。別一覧宛ては removeItem せず残し、正しい一覧で後から消費できるようにする。
      if (parsed && parsed.target === 'staff-blog' && Array.isArray(parsed.values)) {
        sessionStorage.removeItem('c_leeepPendingFilters');
        pendingFilterValues = parsed.values.filter((v) => typeof v === 'string' && v);
      }
    }
  } catch (e) {
    pendingFilterValues = [];
  }

  if (pendingFilterValues.length > 0) {
    const tryApplyPendingFilter = () => {
      const inputs = [...section.querySelectorAll('.LeeepSearchFilterValueInput')];
      const submitBtn = section.querySelector('.LeeepSearchFilterSubmitButton');
      if (inputs.length === 0 || !submitBtn) return false;

      let matched = false;
      pendingFilterValues.forEach((val) => {
        const target = (val || '').trim();
        const input = inputs.find((i) => {
          if ((i.value || '').trim() === target) return true;
          const label = i.closest('.LeeepSearchFilterLabel');
          const nameEl = label && label.querySelector('.LeeepSearchFilterValueName');
          return !!nameEl && nameEl.textContent.trim() === target;
        });
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          matched = true;
        }
      });
      if (!matched) return false;

      submitBtn.click();
      return true;
    };

    if (!tryApplyPendingFilter()) {
      const filterObserver = new MutationObserver(() => {
        if (tryApplyPendingFilter()) filterObserver.disconnect();
      });
      filterObserver.observe(section, { childList: true, subtree: true });
      setTimeout(() => filterObserver.disconnect(), 10000);
    }
  }

  document.addEventListener('onLeeepContentsRendered', (event) => {
    const renderedTagId = String(event && event.detail && event.detail.tag_id || '');
    if (!renderedTagId || renderedTagId !== String(activeTagId)) return;

    const root = document.querySelector('#leeep-embedded-' + renderedTagId);
    if (!root || !section.contains(root)) return;

    root.classList.add('is-leeep-blog-list');
    normalizeStaffBlogFilters();

    /* ---------- 日付挿入 (YYYY.MM.DD) ---------- */
    const blogs = event.detail && event.detail.blogs;
    if (blogs && blogs.length > 0) {
      const items = root.querySelectorAll('.LeeepBlogListItem');
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        const blog = blogs[i];
        if (!blog) continue;

        let timeEl = item.querySelector('time.LeeepBlogDate');
        if (!timeEl) {
          const postedAt = blog.posted_at;
          if (!postedAt) continue;

          const d = new Date(postedAt);
          if (isNaN(d.getTime())) continue;

          const dateIso =
            d.getFullYear() +
            '-' +
            ('0' + (d.getMonth() + 1)).slice(-2) +
            '-' +
            ('0' + d.getDate()).slice(-2);

          const titleEl = item.querySelector('.LeeepBlogListItemTitle');
          if (!titleEl) continue;

          timeEl = document.createElement('time');
          timeEl.className = 'LeeepBlogDate';
          timeEl.setAttribute('datetime', dateIso);
          titleEl.before(timeEl);
        }

        const dt = timeEl.getAttribute('datetime');
        if (dt) {
          const parts = dt.split('-');
          if (parts.length === 3) {
            timeEl.textContent = parts[0] + '.' + parts[1] + '.' + parts[2];
          }
        }
      }
    }

    /* ---------- ページネーション: 1ページなら非表示、先頭・末尾シェブロン制御 ---------- */
    const pagerItems = root.querySelectorAll('.LeeepPagerItem');
    if (pagerItems.length > 0) {
      const pageNumberItems = [...pagerItems].filter(item => !item.querySelector('.LeeepPagerChevron'));
      const pager = root.querySelector('.LeeepPager');

      if (pageNumberItems.length <= 1 && pager) {
        pager.style.display = 'none';
      } else {
        const currentItem = root.querySelector('.LeeepPagerItemCurrent');
        if (currentItem) {
          const first = pagerItems[0];
          const last = pagerItems[pagerItems.length - 1];
          if (first?.querySelector('.LeeepPagerChevron') && currentItem === pagerItems[1]) first.remove();
          if (last?.querySelector('.LeeepPagerChevron') && currentItem === pagerItems[pagerItems.length - 2]) last.remove();
        }
      }
    }
  });

  /* ---------- SP ドロワー ---------- */
  const setupSpDrawers = () => {
    const filterDrawerRoot = section.querySelector('[data-filter-drawer]');
    const sortDrawerRoot = section.querySelector('[data-sort-drawer]');
    const filterBtn = section.querySelector('[data-filter-drawer-toggle]');
    const sortBtn = section.querySelector('[data-sort-drawer-toggle]');
    const sortCurrentEl = section.querySelector('[data-sort-current]');
    if (!filterDrawerRoot || !filterBtn) return;

    const filterBody = filterDrawerRoot.querySelector('[data-drawer-body]');
    const sortBody = sortDrawerRoot ? sortDrawerRoot.querySelector('[data-drawer-body]') : null;
    if (!filterBody) return;

    const leeepFilter = section.querySelector('.LeeepSearchFilter');
    if (!leeepFilter) return;

    // LEEEP の SearchFilter を drawer body にクローン。
    // フィルター確定 → LEEEP 再描画されると drawer 内のクローンが stale になるので、
    // openDrawer のたびに再生成して常に最新のチェック状態を反映する。
    const populateDrawerBody = () => {
      filterBody.innerHTML = '';
      if (sortBody) sortBody.innerHTML = '';
      const currentFilter = section.querySelector('.LeeepSearchFilter');
      if (!currentFilter) return;
      currentFilter.querySelectorAll('.LeeepSearchFilterKey').forEach(key => {
        const name = key.querySelector('.LeeepSearchFilterKeyName');
        if (!name) return;
        const isSort = name.textContent.trim() === '並び順';
        if (isSort && !sortBody) return;
        const target = isSort ? sortBody : filterBody;
        // ラジオは同じ name だとページ内で1グループになり、複製側の選択が元（PC表示）の選択を外してしまう。
        // 複製側の name を変え、元の name は data-c-orig-name に残す。
        const clone = key.cloneNode(true);
        clone.querySelectorAll('input[name]').forEach((input) => {
          input.dataset.cOrigName = input.name;
          input.name = 'c_drawer:' + input.name;
        });
        target.appendChild(clone);
      });
      [filterBody, sortBody].forEach((container) => {
        if (!container) return;
        container.querySelectorAll('.LeeepSearchFilterKey').forEach((key) => {
          delete key.dataset.__accordionReady;
        });
        container.querySelectorAll('.LeeepSearchFilterCategoryToggle').forEach((toggle) => {
          const category = toggle.closest('.LeeepSearchFilterCategory');
          if (!category) return;
          toggle.setAttribute('aria-expanded', String(category.classList.contains('LeeepSearchFilterCategoryOpen')));
        });
      });
      setupFilterShowMore();
      setupAccordionAnimation();

      if (sortBody && sortCurrentEl) {
        const checkedSort = sortBody.querySelector('input:checked');
        if (checkedSort) {
          const valueName = checkedSort.closest('.LeeepSearchFilterLabel')?.querySelector('.LeeepSearchFilterValueName');
          if (valueName) sortCurrentEl.textContent = valueName.textContent.trim();
        }
      }
    };
    populateDrawerBody();

    const openDrawer = (drawer, triggerBtn) => {
      // 開くたびに最新の LEEEP フィルター状態でクローンを再生成（stale 対策）
      populateDrawerBody();
      drawer.classList.add('is-open');
      // TODO: フォローアップ - body.style 直書きを共通スクロールロックユーティリティ
      // (body.is-scroll-locked 等) に置き換える。他コンポーネントとの競合回避のため
      document.body.style.overflow = 'hidden';
      if (triggerBtn) triggerBtn.setAttribute('aria-expanded', 'true');
      const firstFocusable = drawer.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (firstFocusable) firstFocusable.focus();
    };
    const closeDrawer = (drawer, triggerBtn) => {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      if (triggerBtn) triggerBtn.setAttribute('aria-expanded', 'false');
      if (triggerBtn) triggerBtn.focus();
    };

    filterBtn.addEventListener('click', () => openDrawer(filterDrawerRoot, filterBtn));
    if (sortDrawerRoot && sortBtn) {
      sortBtn.addEventListener('click', () => openDrawer(sortDrawerRoot, sortBtn));
    }

    const drawerTriggerMap = [{ drawer: filterDrawerRoot, trigger: filterBtn }];
    if (sortDrawerRoot && sortBtn) drawerTriggerMap.push({ drawer: sortDrawerRoot, trigger: sortBtn });
    drawerTriggerMap.forEach(({ drawer, trigger }) => {
      drawer.querySelector('[data-drawer-close]')?.addEventListener('click', () => closeDrawer(drawer, trigger));
      drawer.querySelector('[data-drawer-overlay]')?.addEventListener('click', () => closeDrawer(drawer, trigger));
      // アコーディオンヘッダーは populateDrawerBody で再クローンされるため、
      // 個別 attach ではなく drawer へのイベント委譲で常に最新クローンに対応
      drawer.addEventListener('click', (e) => {
        const categoryToggle = e.target.closest('.LeeepSearchFilterCategoryToggle');
        if (categoryToggle && drawer.contains(categoryToggle)) {
          e.preventDefault();
          e.stopPropagation();
          const category = categoryToggle.closest('.LeeepSearchFilterCategory');
          if (!category) return;
          const isOpen = category.classList.toggle('LeeepSearchFilterCategoryOpen');
          categoryToggle.setAttribute('aria-expanded', String(isOpen));
          return;
        }

        const header = e.target.closest('.LeeepSearchFilterKeyHeader');
        if (header && drawer.contains(header)) {
          header.closest('.LeeepSearchFilterKey')?.classList.toggle('LeeepSearchFilterItemOpen');
        }
      });
    });

    // keydown は section スコープに限定（テーマエディタ再レンダリングでのリスナー増殖防止）
    section.addEventListener('keydown', (e) => {
      const drawers = sortDrawerRoot ? [filterDrawerRoot, sortDrawerRoot] : [filterDrawerRoot];
      const openDrawer_ = drawers.find(d => d.classList.contains('is-open'));
      if (!openDrawer_) return;

      if (e.key === 'Escape') {
        const trigger = openDrawer_ === filterDrawerRoot ? filterBtn : sortBtn;
        closeDrawer(openDrawer_, trigger);
        return;
      }

      if (e.key === 'Tab') {
        const panel = openDrawer_.querySelector('.c_leeep-section__drawer-panel');
        if (!panel) return;
        const focusables = panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (focusables.length === 0) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    // LEEEP 再描画後、closure の leeepFilter が detach される可能性があるため毎回再クエリ
    const syncAndSubmit = (inputs) => {
      const currentFilter = section.querySelector('.LeeepSearchFilter');
      if (!currentFilter) return;
      inputs.forEach(input => {
        if (input.type === 'radio' && !input.checked) return;
        const origInputs = currentFilter.querySelectorAll('input[name="' + (input.dataset.cOrigName || input.name) + '"]');
        origInputs.forEach(orig => {
          if (input.type === 'radio') orig.checked = (orig.value === input.value);
          else if (orig.value === input.value) orig.checked = input.checked;
        });
      });
      currentFilter.querySelector('.LeeepSearchFilterSubmitButton')?.click();
    };

    filterDrawerRoot.querySelector('[data-filter-submit]')?.addEventListener('click', () => {
      syncAndSubmit(filterBody.querySelectorAll('input'));
      closeDrawer(filterDrawerRoot, filterBtn);
    });

    if (sortBody && sortDrawerRoot) {
      sortBody.addEventListener('change', (e) => {
        if (!e.target.matches('input')) return;
        syncAndSubmit(sortBody.querySelectorAll('input'));
        const valueName = e.target.closest('.LeeepSearchFilterLabel')?.querySelector('.LeeepSearchFilterValueName');
        if (valueName && sortCurrentEl) sortCurrentEl.textContent = valueName.textContent.trim();
        closeDrawer(sortDrawerRoot, sortBtn);
      });
    }
  };

  /* ---------- アコーディオン スライドアニメーション ---------- */
  const filterInitial = Number(section.dataset.filterInitialCount) || 30;
  const filterStep = Number(section.dataset.filterStepCount) || filterInitial;

  const filterGroupKeyOf = (values) => {
    const input = values.querySelector('.LeeepSearchFilterValueInput');
    if (input && input.name) return 'name:' + (input.dataset.cOrigName || input.name);
    const keyEl = values.closest('.LeeepSearchFilterKey');
    const nameEl = keyEl && keyEl.querySelector('.LeeepSearchFilterKeyName');
    return nameEl ? 'label:' + nameEl.textContent.trim() : '';
  };

  const hasCategoryTree = (values) => !!values.querySelector('.LeeepSearchFilterCategory');

  const renderFilterValues = (values) => {
    const labels = Array.from(values.querySelectorAll('.LeeepSearchFilterLabel'));
    /* 店舗階層では LEEEP 側のカテゴリ開閉を優先し、子店舗を件数で隠さない。 */
    if (hasCategoryTree(values)) {
      labels.forEach((label) => label.classList.remove('c_is-filter-hidden'));
      values.removeAttribute('data-c-shown');
      values.querySelector('.c_leeep-filter-more')?.remove();
      return;
    }
    const shown = Number(values.dataset.cShown) || filterInitial;

    let hidden = 0;
    labels.forEach((label, i) => {
      const input = label.querySelector('.LeeepSearchFilterValueInput');
      const isHidden = i >= shown && !(input && input.checked);
      label.classList.toggle('c_is-filter-hidden', isHidden);
      if (isHidden) hidden += 1;
    });

    const button = values.querySelector('.c_leeep-filter-more');
    if (!button) return;
    if (hidden <= 0) {
      button.remove();
      return;
    }
    button.textContent = 'さらに表示（残り' + hidden.toLocaleString() + '件）';
  };

  const setupFilterShowMore = () => {
    section.querySelectorAll('.LeeepSearchFilterValues').forEach((values) => {
      if (hasCategoryTree(values)) {
        renderFilterValues(values);
        return;
      }
      if (values.querySelectorAll('.LeeepSearchFilterLabel').length <= filterInitial) return;
      if (!values.dataset.cShown) values.dataset.cShown = String(filterInitial);
      if (!values.querySelector('.c_leeep-filter-more')) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'c_leeep-filter-more';
        values.appendChild(button);
      }
      renderFilterValues(values);
    });
  };

  section.addEventListener('click', (e) => {
    const button = e.target.closest('.c_leeep-filter-more');
    if (!button || !section.contains(button)) return;
    const values = button.closest('.LeeepSearchFilterValues');
    if (!values) return;
    const next = (Number(values.dataset.cShown) || filterInitial) + filterStep;
    const groupKey = filterGroupKeyOf(values);

    const targets = groupKey
      ? Array.from(section.querySelectorAll('.LeeepSearchFilterValues'))
          .filter((el) => filterGroupKeyOf(el) === groupKey)
      : [values];

    targets.forEach((target) => {
      target.dataset.cShown = String(next);
      renderFilterValues(target);

      const keyEl = target.closest('.LeeepSearchFilterKey');
      const isOpen = !!keyEl && keyEl.classList.contains('LeeepSearchFilterItemOpen');
      if (isOpen && target.style.height && target.style.height !== 'auto') {
        target.style.height = 'auto';
      }
    });
  });

  document.addEventListener('onLeeepContentsRendered', () => {
    normalizeStaffBlogFilters();
    setupFilterShowMore();
  });

  const setupAccordionAnimation = () => {
    section.querySelectorAll('.LeeepSearchFilterKey').forEach((key) => {
      if (key.dataset.__accordionReady) return;
      key.dataset.__accordionReady = '1';

      const values = key.querySelector('.LeeepSearchFilterValues');
      if (!values) return;

      values.style.setProperty('display', 'block', 'important');
      values.style.overflow = 'hidden';
      values.style.transition = 'height 0.3s ease, margin-top 0.3s ease';

      if (key.classList.contains('LeeepSearchFilterItemOpen')) {
        values.style.height = 'auto';
        values.style.marginTop = '24px';
      } else {
        values.style.height = '0px';
        values.style.marginTop = '0px';
      }

      const slideObserver = new MutationObserver(() => {
        const computedHeight = values.getBoundingClientRect().height;
        values.style.transition = 'none';
        values.style.height = computedHeight + 'px';

        if (key.classList.contains('LeeepSearchFilterItemOpen')) {
          const targetHeight = values.scrollHeight + 'px';
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              values.style.transition = 'height 0.3s ease, margin-top 0.3s ease';
              values.style.height = targetHeight;
              values.style.marginTop = '24px';
              values.addEventListener('transitionend', () => {
                if (key.classList.contains('LeeepSearchFilterItemOpen')) {
                  values.style.height = 'auto';
                }
              }, { once: true });
            });
          });
        } else {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              values.style.transition = 'height 0.3s ease, margin-top 0.3s ease';
              values.style.height = '0px';
              values.style.marginTop = '0px';
            });
          });
        }
      });
      slideObserver.observe(key, { attributes: true, attributeFilter: ['class'] });
    });
  };

  const waitAndSetupDrawers = () => {
    const trySetup = () => {
      const leeepFilter = section.querySelector('.LeeepSearchFilter');
      const filterKeys = leeepFilter ? leeepFilter.querySelectorAll('.LeeepSearchFilterKey') : [];
      if (filterKeys.length === 0) return false;
      setupSpDrawers();
      setupFilterShowMore();
      setupAccordionAnimation();
      return true;
    };

    if (trySetup()) return;

    const observer = new MutationObserver(() => {
      if (trySetup()) observer.disconnect();
    });
    observer.observe(section, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 60000);
  };
  waitAndSetupDrawers();
});
